import React, { useState } from 'react'
import UpdatePassword from '../../components/auth/UpdatePassword'

import { useDispatch, useSelector } from 'react-redux'
import { updateProfile } from '../../actions/accountActions'
import { updatePasswordFormValid } from '../../validation'
import {
    convertErrorYup,
    errorHandle,
    ensureArray,
    showMessageSuccess,
} from '../../utils/helper'

const defaultForm = {}

const UpdatePasswordContainer = () => {
    const dispatch = useDispatch()
    const user = useSelector(state => state.AccountReducer.user)

    const [form, setForm] = useState({ ...defaultForm })
    const [errors, setErrors] = useState({})

    const handleInputChange = e => {
        const { name, value } = e.target
        setForm(prev => ({ ...prev, [name]: value }))
    }

    const clearErrorField = field =>
        setErrors(prev => ({ ...prev, [field]: '' }))

    const handleSubmit = async e => {
        e && e.preventDefault()

        try {
            await updatePasswordFormValid.validate(form, { abortEarly: false })
            const { userPassword, userNewPassword } = form
            dispatch(
                updateProfile({
                    params: {
                        ...user,
                        userPassword,
                        userNewPassword,
                        fromShopId: 27,
                    },
                    onDone: ({ responseData, success }) => {
                        if (success) {
                            setForm({ ...defaultForm })
                            // show message success
                            showMessageSuccess('Cập nhật mật khẩu thành công')
                        } else {
                            if (responseData?.data) {
                                setErrors(
                                    ensureArray(responseData?.data).reduce(
                                        (rs, current) => ({
                                            ...rs,
                                            [current.field]: current.message,
                                        }),
                                        {}
                                    )
                                )
                            } else {
                                errorHandle({
                                    message: 'apiMessage.changePasswordFailed',
                                })
                            }
                        }
                    },
                })
            )
        } catch (error) {
            if (error?.name === 'ValidationError') {
                setErrors(convertErrorYup(error))
            }
        }
    }

    return (
        <UpdatePassword
            handleSubmit={handleSubmit}
            form={form}
            handleInputChange={handleInputChange}
            clearErrorField={clearErrorField}
            errors={errors}
        />
    )
}

export default UpdatePasswordContainer
